import { render, staticRenderFns } from "./ItemNotify.vue?vue&type=template&id=10933208&scoped=true&"
import script from "./ItemNotify.vue?vue&type=script&lang=js&"
export * from "./ItemNotify.vue?vue&type=script&lang=js&"
import style0 from "./ItemNotify.vue?vue&type=style&index=0&id=10933208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10933208",
  null
  
)

export default component.exports